import {reportHeartbeatTraceEvent} from './heartbeat';
import {SwitchConversationEvent} from './performanceMetrics/switchConversation';
import {SwitchFolderEvent} from './performanceMetrics/switchFolder';

export enum FetchSourcesEnum {
  SERVER = 'server',
  CACHE = 'cache',
}

export enum TraceEventTypesEnum {
  SWITCH_CONVERSATION = 'switchConversation',
  SWITCH_FOLDER = 'switchFolder',
  INITIAL_APP_LOAD = 'initialAppLoad',
}

interface InitialAppLoadEvent {
  timestamp: number;
  initialResponse: number;
  bootLoad: number;
  appLoad: number;
}

export type TraceEvent =
  | {
      type: TraceEventTypesEnum.SWITCH_CONVERSATION;
      event: SwitchConversationEvent;
    }
  | {
      type: TraceEventTypesEnum.SWITCH_FOLDER;
      event: SwitchFolderEvent;
    }
  | {
      type: TraceEventTypesEnum.INITIAL_APP_LOAD;
      event: InitialAppLoadEvent;
    };

export type UITraceEvent = TraceEvent & {id: number};

export interface CacheStats {
  numPrefetched: number;
  numFetched: number;
  numHits: number;
}

export enum PrefetchEventsEnum {
  PREFETCH,
  NOOP,
}

interface PrefetchActionEvent {
  type: PrefetchEventsEnum.PREFETCH;
  conversationId: number;
  isSuccess: boolean;
}

interface PrefetchNoopEvent {
  type: PrefetchEventsEnum.NOOP;
  count: number;
}

type PrefetchEvent = PrefetchActionEvent | PrefetchNoopEvent;

export interface PrefetchStats {
  log: Array<PrefetchEvent>;
}

const maxTraceEvents = 15;
const recentEvents: Array<UITraceEvent> = [];

const cacheStats = {
  numPrefetched: 0,
  numFetched: 0,
  numHits: 0,
} as CacheStats;

const maxPrefetchEvents = 10;
const prefetchStats = {
  log: [],
} as PrefetchStats;

export function getRecentTraceEvents() {
  return recentEvents;
}

export function getCacheStats() {
  return cacheStats;
}

export function getPrefetchStats() {
  return prefetchStats;
}

export function reportPrefetch(conversationId: number, isSuccess: boolean) {
  cacheStats.numPrefetched++;

  prefetchStats.log.unshift({
    type: PrefetchEventsEnum.PREFETCH,
    conversationId,
    isSuccess,
  });

  while (prefetchStats.log.length > maxPrefetchEvents) {
    prefetchStats.log.pop();
  }
}

export function reportPrefetchNoop() {
  const latestEvent = prefetchStats.log[0];

  if (latestEvent && latestEvent.type === PrefetchEventsEnum.NOOP) {
    latestEvent.count++;
    return;
  }

  prefetchStats.log.unshift({
    type: PrefetchEventsEnum.NOOP,
    count: 1,
  });

  while (prefetchStats.log.length > maxPrefetchEvents) {
    prefetchStats.log.pop();
  }
}

let currentUiEventId = 0;
export function reportTraceEvent(traceEvent: TraceEvent) {
  recentEvents.unshift({id: currentUiEventId++, ...traceEvent});

  updateCacheStats(traceEvent);

  while (recentEvents.length > maxTraceEvents) {
    recentEvents.pop();
  }

  reportHeartbeatTraceEvent(traceEvent);
}

function updateCacheStats(traceEvent: TraceEvent) {
  if (traceEvent.type !== TraceEventTypesEnum.SWITCH_CONVERSATION) {
    return;
  }

  const {fetchInfos} = traceEvent.event;

  if (!fetchInfos) {
    return;
  }

  cacheStats.numFetched++;

  if (fetchInfos.source === FetchSourcesEnum.CACHE) {
    cacheStats.numHits++;
  }
}
